import useAppStore from "@/store/app";
import { CallbackRequest, ChatWidgetActionRequest, ChatWidgetTicketInfoRequest, ChatWidgetTypingRequest, SendRequest } from "@/TickApi";
import { RtcHubInstance } from "./RtcHubInstance";

class ChatWidgetRtcHub extends RtcHubInstance {


  protected subscribeToEvents() {
    this.on("test", (data: unknown) => {
      console.log("RTC test", JSON.stringify(data));
    });

    this.on("patchMessage", (data: ChatWidgetActionRequest) => {
      //console.log("RTC patchMessage", JSON.stringify(data));
      useAppStore().patchMessage(false, data, false);
    });

    this.on("patchActionData", (data: ChatWidgetTypingRequest) => {
      //console.log("RTC patchActionData", data);
      useAppStore().patchActionData(data);
    });

    this.on("patchTicketInfo", (data: ChatWidgetTicketInfoRequest) => {
      //console.log("RTC patchActionData", JSON.stringify(data));
      useAppStore().patchTicketInfo(data);
    });
  }

  // public send(params: SendRequest) {
  //   this.call("Send", params);
  // }

  // public replyOptionCallback(params: CallbackRequest) {
  //   this.call("ReplyOptionCallback", params);
  // }

  protected startSubscription(id: string) {
    console.log("START widget Hub");
  }

  protected endSubscription(id: string) {
    console.log("END widget Hub");
  }

}

export default new ChatWidgetRtcHub();
